import { useEffect } from 'react';
import { tokenStorage } from '../utils/tokenStorage';

/**
 * SessionMonitor — only tracks user activity.
 * Token refresh and logout are handled entirely by the api.ts interceptor.
 * No toasts, no popups, no competing logout logic.
 */
const SessionMonitor: React.FC = () => {
  useEffect(() => {
    const trackActivity = () => {
      tokenStorage.updateLastActivity();
    };

    const events = ['mousedown', 'keydown', 'scroll', 'touchstart', 'click'];

    events.forEach((event) => {
      document.addEventListener(event, trackActivity, { passive: true, capture: true });
    });

    return () => {
      events.forEach((event) => {
        document.removeEventListener(event, trackActivity, true);
      });
    };
  }, []);

  return null;
};

export default SessionMonitor;
